<template>
    <div>
        <!--功能列-->
        <div class="btare">
            <div class="backrul">
                <a href="javascript:void(0)" @click="gotoList()"> 
                    返回查詢結果
                </a>
            </div>
        </div>
        <b-row>
            <b-col>
                <label>使用者帳號*</label>
                <template v-if="DetailData.userAccount && id!= 0">
                    </br>
                    <label>{{ DetailData.userAccount }}</label>
                </template>
                <template v-else>
                    <b-form-input
                        placeholder="請輸入使用者帳號"
                        maxlength="16"
                        v-model="DetailData.userAccount">
                    </b-form-input>
                </template>

            </b-col>
            <b-col>
                <label>使用者姓名*</label>
                <template v-if="!isblack || id== 0" >
                    <b-form-input
                        placeholder="請輸入使用者姓名"
                        maxlength="16"
                        v-model="DetailData.userName">
                    </b-form-input>
                </template>
                <template v-else>
                    </br>
                    <label>{{ DetailData.userName}}</label>
                </template>
            </b-col>
            <b-col v-if="!isblack && DetailData.userAccount!= 'sysmanager'">
                <label>所屬群組*</label>
                <template v-if="!isblack || id== 0">
                    <b-form-select
                        class="only-button-down"
                        :options="groupOptions"
                        v-model="DetailData.AG_ID">
                    </b-form-select>
                </template>
                <template v-else>
                    </br>
                    <label>{{ DetailData.AG_Name  }}</label>
                </template>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <label>電子郵件*</label>
                <template  v-if="!isblack || id== 0">
                    <b-form-input
                        placeholder="請輸入電子郵件"
                        maxlength="100"
                        v-model="DetailData.email">
                    </b-form-input>
                </template>
                <template v-else>
                    </br>
                    <label>{{ DetailData.email }}</label>
                </template>
            </b-col>
            <b-col>
                <label>啟用狀態*</label>
                <template v-if="!isblack || id== 0"> 
                    <b-form-select 
                        class="only-button-down"
                        :options="statusOptions"
                        v-model="DetailData.status">
                    </b-form-select>
                </template>
                <template v-else>
                    </br>
                    <label>{{ statusOptions.filter(x=> x.value == DetailData.status )[0].text }}</label>
                </template>
            </b-col>
        </b-row>
        <b-row>
            <b-col v-if="!isblack || id== 0">
                <span>使用者密碼*</span>
                <div class="card-header h5 px-3 py-2" style="font-size:0.8em" >
                    密碼長度6個字元~12個字，以英文大小寫、數字等限定，需至少一位大寫、一位小寫、一位數字、一位特殊字元(如：!@#$%^&*)
                </div>
                
                <b-form-input
                    :type="passSetting.type"
                    placeholder="請輸入使用者密碼"
                    maxlength="12"
                    v-model="DetailData.pass">
                </b-form-input>
                <a href="javascript:void(0)" @click="showPwdEye(passSetting)">
                    <img class="showeye" v-bind:src="'/images/backend/'+passSetting.image" alt="顯示或隱藏明碼"/>
                </a>
            </b-col>    
        </b-row>
        <b-row>
            <b-col v-if="!isblack || id== 0">
                <span>確認密碼*</span>
                <div class="card-header h5 px-3 py-2" style="font-size:0.8em" >
                    密碼長度6個字元~12個字，以英文大小寫、數字等限定，需至少一位大寫、一位小寫、一位數字、一位特殊字元(如：!@#$%^&*)
                </div>
                <b-form-input
                    :type="confpassSetting.type"
                    placeholder="請輸入使用者密碼"
                    maxlength="12"
                    v-model="DetailData.chkpass">
                </b-form-input>
                <a href="javascript:void(0)" @click="showPwdEye(confpassSetting)">
                    <img class="showeye" v-bind:src="'/images/backend/'+confpassSetting.image" alt="顯示或隱藏明碼"/>
                </a>
            </b-col>    
        </b-row>
        <!--紀錄區-->
        <b-form-group
            label-size="lg"
            class="p-3 mb-2 bg-secondary text-white mt-3"
            style="opacity: 0.75;"
            v-if=" DetailData.loginIP || DetailData.creatorName || DetailData.modifierName">
            <b-row v-if="DetailData.loginIP">
                最後登入紀錄：{{DetailData.loginIP}} ({{datetimeFormatFloat(DetailData.loginDate)}})
            </b-row>
            <b-row v-if="DetailData.creatorName">
                建檔記錄：{{DetailData.creatorName}} ({{ datetimeFormatFloat(DetailData.createDate) }})
            </b-row>
            <b-row v-if="DetailData.modifierName">
                異動紀錄：{{DetailData.modifierName}} ({{ datetimeFormatFloat(DetailData.modifyDate) }})
            </b-row>
        </b-form-group>
        <!--功能操作區-->
        <div class="mt-3" v-if="!isblack || id== 0" >
            <b-button @click="save">
                儲存
            </b-button>
            <b-button @click="unLocked" v-if="id!=0">
                解除鎖定
            </b-button>
        </div>
    </div>
</template>
<script>
import DeleteModal from '../../Tool/deleteModal.vue';

export default{
    components:{
    },
    data(){
        return{
            //類別編號
            PJ_ID:"",
            //樣式編號
            modal:"",
            //群組選項
            groupOptions:[],
            //啟用選項
            statusOptions:[
                {value: null ,text:"請選擇帳號狀態"},
                {value: 0 ,text:"停用"},
                {value: 1 ,text:"啟用"},
            ],
            //密碼顯示設定
            passSetting:{
                show: false,
                type: "password",
                image: "eye.png",
            },
            //確認密碼顯示設定
            confpassSetting:{
                show: false,
                type: "password",
                image: "eye.png",
            },
            //詳細資料
            DetailData:{AG_ID:null,status:null},
            //排除名單(使用者)
            blacklist:[
                {value:"sysmanager"},
            ],
            //排除名單(權限)
            blacklist_group:[
                {value: "AG7tyaLW8sSd2VvcW4q6Jww"},
            ],
            //帳號編號
            id:0,
            //是否被列入排除名單
            isblack:false,
            //是否開啟自己帳號
            ismyself:false,

            //是否更新
            isUpdate:false,

            //API設定區
            apiUserInfo:(data) => this.userRequest.post("bicd/UserInfo",data),
        };
    },
    props:["value"],
    computed:{
    },
    mounted(){
        //初始化
        this.init();

    },
    watch:{
        groupOptions(){
            this.DetailData.AG_Name = this.groupOptions.filter(x=> x.value == this.DetailData.AG_ID)[0].text;
        }
    },
    methods:{
        //初始化
         init(){
            //類別編號
            this.PJ_ID = this.value.PJID;
            //樣式編號
            this.modal = this.value.modal;
            //取得目前選擇的帳號編號
            this.id = Number(this.$route.query.id);
            this.showPwdEye(this.passSetting,'init');
            this.showPwdEye(this.confpassSetting,'init');
            //取得所有群組項目
            this.getGroup();
            if(this.id != 0){
                //取得帳號詳細資訊
                this.getAccount();
            }   
            
        },
       //取得所有群組項目
        async getGroup(){
            try{
                //初始預設
                this.groupOptions.push({value:null, text:"請選擇所屬群組"});
                //POST 參數
                let jsonReq={
                    TYPE:"GROUP_OPTION",
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/UserInfo",jsonReq); 
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    if(jsonData.length >0){
                        jsonData.forEach((item)=>{
                            if(this.blacklist_group.filter(x => x.value == item.key).length == 0){
                                this.groupOptions.push({value:item.key,text:item.value});
                            }
                        });
                    }
                }
            }catch(err){
                console.log("ErrFunction: getGroup/n "+err);
            }
        },
        //取得帳號詳細資訊
        async getAccount(){
            try{
                //POST 參數
                let jsonReq = {
                    TYPE: "SELECT",
                    VerifyCode: this.PJ_ID,
                    user_info_SELECT: {
                        userId: this.id,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token"); 
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/UserInfo",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if (json.Status) {
                    if(json.Data != null){
                        //有資料時，讀取資料並切換為修改模式
                        let jsonData = JSON.parse(json.Data);
                        this.DetailData = jsonData;
                        this.DetailData.status = Number(this.DetailData.status);
                        
                        //更改狀態為修改
                        this.isUpdate = true;
                    }else{
                        //預設空值
                        this.DetailData ={
                            id:0,
                            AG_ID:null,
                            status:null
                        }
                    }
                    //判斷是否被列入排除名單
                    this.black();
                }
            }catch(err){
                console.log("ErrFunction: getAccount/n "+err);
            }
        },
        //判斷是否被列入排除名單
        black(){
            let userAccount = sessionStorage.getItem("LoginAcc");
            if(userAccount == "sysmanager"){
                //若為最高權限使用者時
                this.isblack = false;
            }else{
                //若為其他使用者時
                 //是否被列入排除名單
                this.isblack =  this.blacklist.filter(x =>x.value == this.DetailData.userAccount).length > 0;

                if(this.DetailData.userAccount == userAccount ){
                    //是否開啟自己帳號
                    this.ismyself = true ;
                    this.isblack = false;

                }else{
                    this.ismyself = false;
                }
            }
        },

        //儲存
        save() {
            try{
                let json_list = {
                    userId:this.id,
                    userName: this.DetailData.userName,
                    userAccount: this.DetailData.userAccount,
                    password: this.DetailData.pass,
                    checkPassword: this.DetailData.chkpass,
                    email: this.DetailData.email,
                    status: this.DetailData.status,
                    AG_ID: this.DetailData.AG_ID,
                }

                if(this.isUpdate){
                    //更新修改功能
                    let json = {
                        TYPE:"UPDATE",
                        VerifyCode: this.PJ_ID,
                        User_Info_UPDATE:json_list,
                    };
                    this.FunctionToken(this.functionUpdate,json);
                }else{
                    //更新修改功能
                    let json = {
                        TYPE:"INSERT",
                        VerifyCode: this.PJ_ID,
                        User_Info_INSERT:json_list,
                    };
                    this.FunctionToken(this.functionInsert,json);
                }
            }catch(err){
                console.log("ErrFunction: save/n "+err);
            }
        },
       //新增功能
        functionInsert(data){
            this.apiUserInfo(data)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status){
                        //this.$bvToast.toast("新增成功",{title:"提示",solid:true,});
                        alert("新增成功");
                        this.gotoList();
                    }else{
                        //發生錯誤時，跳出提示                        
                        alert(this.Str_Replace(JSON.parse(json.Data),",","\r\n"));
                    }
                })
                .catch((err) =>{
                    console.log("ErrorFunction: functionInsert/n" ,err);
                });
        },
        //更新功能
        functionUpdate(data){
            this.apiUserInfo(data)
                .then((res) => {
                    let json= JSON.parse(res.data);
                    if(json.Status){
                        //this.$bvToast.toast("更新成功",{title:"提示",solid:true,});
                        alert("更新成功");
                        this.gotoList();
                    }else{
                        //發生錯誤時，跳出提示
                        alert(this.Str_Replace(JSON.parse(json.Data),",","\r\n"));
                    }
                })
                .catch((err)=>{

                    console.log("ErrorFunction: functionInsert/n" ,err);
                });
        },

        //解除鎖定
        async unLocked(){
            try{
                //POST 參數
                let jsonReq = {
                    TYPE: "UNLOCK",
                    VerifyCode:this.PJ_ID,
                    User_Info_UPDATE:{
                        userAccount :this.DetailData.userAccount,
                    }
                }
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/UserInfo",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    this.$bvToast.toast("帳號已解除鎖定",{
                        title:"提示",
                        solid:true,
                    });
                }else{
                    this.$bvToast.toast("解除鎖定失敗",{
                        title:"警告",
                        solid:true,
                    });
                }

            }catch(err){
                console.log("ErrFunction: unLocked/n "+err);
            }
        },
        //跳轉至列表頁面
        gotoList(gotoid=0){
            this.$router.replace({
                path: this.$route.path,
                query:{
                    PJID:this.$route.query.PJID,
                    modal:2,
                }
            });
        },
    },
}
</script>